import BreadCrumbs from '@/components/atom/BreadCrumbs';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import { Client, ClientType } from '@/types/app';
import { ROUTES } from '@/types/common';
import { DiseaseEncyclopediaSelectSubjectViewModel } from '@/views/disease-encyclopedia/select-subject/hooks/useDiseaseEncyclopediaSelectSubjectViewModel';
import React from 'react';
import Department from './Department';

interface Props {
  client: Client;
  viewModel: DiseaseEncyclopediaSelectSubjectViewModel;
}

const DiseaseEncyclopediaSelectSubjectView = (props: Props) => {
  return (
    <TemplateLayout.Wrapper>
      {props.client.clientType === ClientType.WEB && (
        <BreadCrumbs.Wrapper>
          <BreadCrumbs
            visible
            name='과목 선택'
            type='disease_encyclopedia'
            path={`${ROUTES.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path}`}
          />
        </BreadCrumbs.Wrapper>
      )}
      <TemplateLayout.Content>
        <h1 className={'typography-ui-22sb flex h-[60px] items-center pr-[20px] pl-[24px] text-gray-900'}>과목 선택</h1>

        <section>
          <ul className={'flex flex-col'}>
            {props.viewModel.departmentCategories.map((departmentCategory) => (
              <Department key={departmentCategory.id} departmentCategory={departmentCategory} />
            ))}
          </ul>
        </section>
      </TemplateLayout.Content>
    </TemplateLayout.Wrapper>
  );
};

export default DiseaseEncyclopediaSelectSubjectView;
